/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';

/**
 * MaterialRounded Desktop Windows.
 */

export const ICON_DESKTOP_WINDOWS = (
  <svg fill="none" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14 1.33301H1.99996C1.26663 1.33301 0.666626 1.93301 0.666626 2.66634V10.6663C0.666626 11.3997 1.26663 11.9997 1.99996 11.9997H6.66663L5.57996 13.633C5.28663 14.073 5.59996 14.6663 6.13329 14.6663H9.86663C10.4 14.6663 10.72 14.073 10.42 13.633L9.33329 11.9997H14C14.7333 11.9997 15.3333 11.3997 15.3333 10.6663V2.66634C15.3333 1.93301 14.7333 1.33301 14 1.33301ZM14 9.33301H1.99996V3.33301C1.99996 2.96634 2.29996 2.66634 2.66663 2.66634H13.3333C13.7 2.66634 14 2.96634 14 3.33301V9.33301Z"
      fill="#4F4F4F"
    />
  </svg>
);
